module.exports = __webpack_public_path__ + "img/supplychain_rights.06d166d1.png";